import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

export interface ExportManualParams {
  manualId: string;
  contentId?: string;
  exportType: 'PDF' | 'DOCX';
  showEditLevelTags: boolean;
  showAccreditationTags: boolean;
  toc?: boolean;
}

export interface ExportManualResponse {
  jobId?: string;
  presignedUrl?: string;
  base64?: string;
  fileType?: 'PDF' | 'DOCX';
}

export const getExportManualData = async (params: ExportManualParams): Promise<ExportManualResponse> => {
  const { manualId, contentId, exportType, showEditLevelTags, showAccreditationTags, toc } = params;

  let url: string;
  if (contentId) {
    url = `${baseApiUrl()}/lexiverse/export/v1/manuals/${manualId}/content/${contentId}/export`;
  } else {
    url = `${baseApiUrl()}/lexiverse/export/v1/manuals/${manualId}/export`;
  }

  const queryParams = new URLSearchParams({
    exportType,
    showEditLevelTags: showEditLevelTags.toString(),
    showAccreditationTags: showAccreditationTags.toString(),
  });

  if (!contentId && toc !== undefined) {
    queryParams.set('toc', toc.toString());
  }

  const finalUrl = `${url}?${queryParams.toString()}`;

  const data = await fetcher({
    method: 'get',
    url: finalUrl,
  });

  return data;
};

export default function useManageExportManual() {
  const exportManual = async (
    params: ExportManualParams,
    callback?: (data: ExportManualResponse) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    try {
      const data = await getExportManualData(params);
      if (callback) callback(data);
      return data;
    } catch (err) {
      if (onError) handleError(err as Error, { onError });
      throw err;
    }
  };

  return {
    exportManual,
  };
}
